<script setup>
import { storeToRefs } from 'pinia';

// // Store management imports
import { useBreakStore } from '@/stores/break';
import { useDirectionStore } from '@/stores/direction';
// import { useGeneralStore } from '@/stores/general';

// // Module imports
import TempEmojiPoll from './SimplePolls/TempEmojiPoll.vue';
import TempPIPPoll from './SimplePolls/TempPIPPoll.vue';
import TempRightThirdScan from './TransparentOverlays/TempRightThirdScan.vue';
import TempProductHotspots from './TransparentOverlays/TempProductHotspots.vue';
import TempPickSellerAndOfferings from './MultiStageOverlays/TempPickSellerAndOfferings.vue';
import TempLowerHeroPoll from './HeroPolls/TempLowerHeroPoll.vue';
import TempTriviaPoll from './SimplePolls/TempTriviaPoll.vue';
import TempPollStreamOverlay from './SimplePolls/TempPollStreamOverlay.vue';
// import TempOneLowerDeal from './TransparentOverlays/TempOneLowerDeal.vue';
// import TempOneLowerRightExpandableDeal from './TransparentOverlays/TempOneLowerRightExpandableDeal.vue';
// import TempThreeLowerCycleDeal from './TransparentOverlays/TempThreeLowerCycleDeal.vue';

const { directionModule } = storeToRefs(useDirectionStore());
const { isBreakReady, breakUuid } = storeToRefs(useBreakStore());

// // SamsungShopping functions

const callDirectionModule = () => {
  return directionModule.value;
};

const isBreakDataReady = () => {
  return isBreakReady.value && breakUuid.value;
};
</script>

<template>
  <main class="samsung-shopping">
    <div class="samsung-shopping__container">
      <TempEmojiPoll v-if="callDirectionModule() === 'TempEmojiPoll'" />

      <TempPIPPoll v-else-if="callDirectionModule() === 'TempPIPPoll' && isBreakDataReady()" />

      <TempRightThirdScan v-else-if="callDirectionModule() === 'TempRightThirdScan'" />

      <TempProductHotspots
        v-else-if="callDirectionModule() === 'TempProductHotspots' && isBreakDataReady()"
      />

      <TempPickSellerAndOfferings
        v-else-if="callDirectionModule() === 'TempPickSellerAndOfferings' && isBreakDataReady()"
      />

      <TempLowerHeroPoll
        v-else-if="callDirectionModule() === 'TempLowerHeroPoll' && isBreakDataReady()"
      />

      <TempTriviaPoll
        v-else-if="callDirectionModule() === 'TempTriviaPoll' && isBreakDataReady()"
      />

      <TempPollStreamOverlay
        v-else-if="callDirectionModule() === 'TempPollStreamOverlay' && isBreakDataReady()"
      />
      <!-- <TempOneLowerRightExpandableDeal v-else-if="callDirectionModule() === 'TempOneLowerRightExpandableDeal'" />
      <TempThreeLowerCycleDeal v-else-if="callDirectionModule() === 'TempThreeLowerCycleDeal'" />
      <TempOneLowerDeal v-else-if="callDirectionModule() === 'TempOneLowerDeal'" /> -->
    </div>
  </main>
</template>

<style lang="scss">
@use './samsungshopping.scss';
</style>
